"use client";

import { useEffect } from "react";
import { clearStaleDeploymentFlag } from "@/lib/observability/stale-deployment";

/**
 * Monté dans le layout racine : si l'app s'affiche, c'est que le bundle est à
 * jour → on réarme le rechargement automatique pour le prochain déploiement.
 */
export function StaleDeploymentReset() {
  useEffect(() => {
    clearStaleDeploymentFlag();
  }, []);
  return null;
}
